import { Component } from '@angular/core';

@Component({
  selector: 'om-svg-pill-circled',
  template: `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#C5E5DD" />
      <path
        d="M17.938 11.8191C21.0613 10.0159 25.0552 11.086 26.8585 14.2093L30.1236 19.8647L18.8128 26.395L15.5477 20.7396C13.7444 17.6163 14.8146 13.6224 17.938 11.8191Z"
        fill="white"
        stroke="#005450"
        stroke-width="1.25"
      />
      <path
        d="M31.0269 34.4895C27.9036 36.2927 23.9096 35.2226 22.1064 32.0992L18.8413 26.4439L30.152 19.9136L33.4172 25.569C35.2204 28.6923 34.1502 32.6862 31.0269 34.4895Z"
        fill="white"
        stroke="#005450"
        stroke-width="1.25"
      />
      <ellipse
        cx="25.0201"
        cy="27.6626"
        rx="1.7888"
        ry="1.7888"
        transform="rotate(-30 25.0201 27.6626)"
        fill="#005450"
      />
      <ellipse
        cx="29.9071"
        cy="28.9712"
        rx="1.7888"
        ry="1.7888"
        transform="rotate(-30 29.9071 28.9712)"
        fill="#005450"
      />
    </svg>
  `,
  standalone: true,
})
export class SvgPillCircledComponent {}
